export async function performSearch(query) {
    try {
        if (query) {
            const response = await fetch('/api/search?q=' + query);
            const result = await response.json();

            return result.docs
        }

        return [];
    } catch (error) {
        try {
            // eslint-disable-next-line compat/compat
            const devResponse = await fetch('/api/search.json?q=' + query);
            const result = await devResponse.json();

            return result.docs
        } catch (error) {
            console.error('Failed to load search:', error);
            throw error;
        }
    }
}
